import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { deleteOrderInd } from "../thunks/deleteOrderInd";
import { setFetchState } from "../orderIndDataReducer";

export const useOrderIndDelete = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (store) => store.data.trading.orderind.cancelFetchState
  );

  const dispatch = useDispatch();
  const dispatchDeleteOrderInd = React.useCallback(
    (id: number) => dispatch(deleteOrderInd(id)),
    [dispatch]
  );

  React.useEffect(() => {
    dispatch(setFetchState({ type: "not-started" }));
  }, [dispatch]);

  return [fetchState, dispatchDeleteOrderInd] as [
    typeof fetchState,
    typeof dispatchDeleteOrderInd
  ];
};
